<template>
<div id="giftPack_iframebox" v-if="visible">
    <div class="verify" >
        <div class="novice_w1">
            <!-- 新手大礼包 -->
            <div class="novice_gift " :class="{ hide: step != 1 }">
                <div class="gift_an">
                    <a href="javascript:void(0);" class="gift_btn gift_btn_anim gift_Get"  @click="giftGet"><span>开心收下</span></a>
                </div>
            </div>
            <!-- 领取成功 -->
            <div class="receive_gift " :class="{ hide: step != 2 }">
                <div class="receive_all gift_an df js-sb">
                    <a :href="`/my/myCoupon.php`" class="gift_btn gift_btn_01" target="_blank"
                        ><span>查看88元学习金</span></a>
                    <a :href="`/vip/`" class="gift_btn gift_btn_02" id="skipVip" target="_blank"
                    @click="getSkipVip"
                    ><span>体验超级VIP课程</span></a>
                </div>
            </div>
            <!-- 已领取 -->
            <div class="already_gift " :class="{ hide: step != 4 }">
                <div class="gift_an">
                    <!-- <p class="already_title">亲，您已领过大礼包哦!</p> -->
                    <a href="/bc/" class="gift_btn gift_btn_anim gift_btn_01 already_an"  target="_blank"><span>立即选课学习</span></a>
                </div>
            </div>
        </div>
        <a href="javascript:void(0);" class="verify-close-btn" id="verify-closeBtn" @click="closeGiftBag"></a>
    </div>
</div>

</template>
<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import { giftBag, getGiftBagNew, commentIsLogin } from "@/api/common"

export default {
    data() {
        return {
            visible:false,
            show:true,
            step:1,
            layerFrom:1,
            qrcode: require('../../assets/giftbag/images/wx-ewm.png'),
            visible: false,
        };
    },
    created(){

    },
    computed:{
        // ...mapGetters(['token']),
        token:function(){
            let token= getToken()
            return token
        },
    },
    mounted() {
        let HREF_API = process.env.VUE_APP_HREF_API
        let _gift_bag_click = this.getCookie('_gift_bag_click')
        
        //点击过领取新手大礼包，登录后刷新页面重新触发点击
        if (_gift_bag_click) {
            // console.log("_gift_bag_click","被触发")
            // let data = {
            //     show_error_msg: false
            // }
            // commentIsLogin(data).then(res => {
            //     console.log("commentIsLogin",res)
            //     if (res.error != '-1') { //登录
            //         this.giftGet()
            //     }
            // })
            if(this.token){
                this.giftGet();
            }
            this.setCookie('_gift_bag_click', "", -1);
        }
    },
    methods: {
        curStep(index_){
            return {
                hide: this.step != index_
            }
        },
        giftGet(){
            let pageSource = this.pageSource()
            this.statisticsClick(pageSource, 2)
            this.getGiftbag(pageSource)

        },
        async getGiftbag(flag){
            let data= {
                flag: flag,
                // show_error_msg: false
            }
            let res = await getGiftBagNew(data)
            res = res.data;
            if (res.code == 1) {
                this.step=2
                this.layerFrom=2
                //更换二维码
                // this.qrcode= res.QRCode
            } else {
                if (res.code == -2) {
                    //已领
                    this.step = 4
                    // this.qrcode = res.QRCode
                } else if (res.code == -3) {
                    this.$toast.center(res.msg);
                    this.$login.show();
                    //登录前立即领取，设置cookie,登录后刷新页面直接拉起新手大礼包iframe
                    this.setCookie('_gift_bag_click', 1);
                } else {
                    this.$toast.center(res.msg);
                }
            }
        },
        getSkipVip(){
            // 发起请求（体验VIP）
            let pageSource = this.pageSource()
            this.statisticsClick(pageSource, 4)
        },
        getGiftVip() {
            //点击加领vip打开微信二维码
            let pageSource = this.pageSource()
            this.statisticsClick(pageSource, 6)
            this.step=3
        },
        closeGiftBag(){
            let pageSource = this.pageSource()
            if(this.layerFrom==1){
                this.statisticsClick(pageSource, 5);
            } else if (this.layerFrom == 2) {
                this.statisticsClick(pageSource, 3);
            }
            this.setCookie('_iframe_giftPacks', 1);
            this.visible = false
        },
        // 统计展示&点击次数
        statisticsClick(pageFrom, step) {
            let data = {
                'option': 'tj',
                'page_from': pageFrom,
                'step': step,
                'platform': 2
            }
            giftBag(data)
        },
        pageSource() {// 判断页面来源
            var _pageSource = 0;
            //获取URL的路径部分
            var pathname = window.location.pathname;
            //截取一级路径名称
            var first_path = pathname.substr(1, pathname.indexOf('/', pathname.indexOf('/') + 1) - 1);
            if (pathname == '/' || pathname == '/home') { //首页
                _pageSource = 1;
            } else if (first_path == 'tutorials') { //大搜页
                _pageSource = 2;
            } else if (first_path == 'guide') { //软件入门
                _pageSource = 3;
            } else if (first_path == 'bc') { //大师课
                _pageSource = 4;
            } else if (first_path == 'vip') { //VIP专区
                _pageSource = 5;
            } else if (first_path == 'center') { //个人中心
                _pageSource = 6;
            } else if (first_path == 'soft_intro') { //宝典专题页
                _pageSource = 7;
            }else{
                _pageSource = 9;//新人大礼包活动落地页
            }
            return _pageSource;
        },
        setCookie(name, value) {//两个参数，一个是cookie的名子，一个是值
            var Days = 1; //此 cookie 将被保存 1 天
            var exp = new Date();    //new Date("December 31, 9998");
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
            document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
        },
        getCookie(name) {//取cookies函数
            var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
            if (arr != null) return unescape(arr[2]);
            return null;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/giftbag/css/m_giftbag_iframe_20260115.css'
</style>
